import styled from 'styled-components';
import { Heading } from '@alefeducation/ui-elements-library-core';
import ContentRepositorySearch from './ContentRepositorySearch';
import { CONTENT_MANAGEMENT_SETTING } from '../../../../utils/constants';
import { OrganisationSettingVM } from '../../../../apollo/queries/organisations/organisationSetting.queries';

const StyledContainer = styled.div``;

interface Props {
  settings: OrganisationSettingVM[];
  onUpdate: (setting: OrganisationSettingVM) => void;
}

const ContentManagement = (props: Props) => {
  const { settings, onUpdate } = props;
  const [contentManagement] = settings;

  return (
    <StyledContainer data-testid="content-management-container">
      <Heading variant="heading-small">{CONTENT_MANAGEMENT_SETTING}</Heading>
      {contentManagement && (
        <ContentRepositorySearch
          setting={contentManagement}
          onUpdate={onUpdate}
        />
      )}
    </StyledContainer>
  );
};

export default ContentManagement;
